import { createContext, useContext } from "react";

export type LastAddedItem = {
  name: string;
  quantity: number;
  heroImageUrl: string | null;
  productId: number;
  supplierId: number;
  supplierName: string;
  supplierUrlId: string;
  containerType: string;
  sdBasketId: string;
  price: number | null;
  priceIsFromConnection: boolean;
};

export type MarketBasketFeedbackContextType = {
  lastAddedItem?: LastAddedItem;
  flyoverVisible: boolean;
  showFlyover: (item: NonNullable<LastAddedItem>) => void;
  hideFlyover: () => void;
  viewBasket: () => void;
};

export const MarketBasketFeedbackContext =
  createContext<MarketBasketFeedbackContextType | null>(null);

export const useMarketBasketFeedback = () => {
  const context = useContext(MarketBasketFeedbackContext);
  if (!context) {
    throw new Error(
      "useMarketBasketFeedback must be used within a MarketBasketFeedbackProvider",
    );
  }
  return context;
};
